import React from 'react';
export function Highlight({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="text-accent" data-id="element-27" data-mp="1y84vu13zvtb">
      {children}
    </span>;
}